@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.destinations

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto


object GetPassengerHistoryEndpoint :
    EndPoint<GetPassengerHistoryEndpoint.Request, GetPassengerHistoryEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String,
        val data: PassengerPointFilterDto,
    )

    class Response(
        val passengerDestinations: Array<LocationPointDto>,
    )
}